/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* CODE FOR EXTERNAL LINKS TO OPEN IN A NEW TAB + NO FOLLOW */
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'nofollow noreferrer noopener';
  }
}




  /* CHILLA: keep the back-to-top button (mobile only) stacked below the WhatsApp floating button */
  (function () {
    function isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    function isFixedOrSticky(el) {
      if (!el || el.nodeType !== 1) return false;
      var pos = window.getComputedStyle(el).position;
      return pos === 'fixed' || pos === 'sticky';
    }

    function findFixedWithin(root) {
      if (!root) return null;
      if (isFixedOrSticky(root)) return root;
      var kids = root.querySelectorAll ? root.querySelectorAll('*') : [];
      for (var j = 0; j < kids.length; j++) {
        if (isFixedOrSticky(kids[j])) return kids[j];
      }
      return null;
    }

    function looksLikeWhatsApp(el) {
      var tag = (el.tagName || '').toLowerCase();
      var idcls = ((el.id || '') + ' ' + (el.className && el.className.toString ? el.className.toString() : '')).toLowerCase();
      var href = (el.getAttribute && (el.getAttribute('href') || '')).toLowerCase();
      var src = (el.getAttribute && (el.getAttribute('src') || '')).toLowerCase();
      var title = (el.getAttribute && (el.getAttribute('title') || '')).toLowerCase();
      return tag.indexOf('whatsapp') !== -1 || idcls.indexOf('whatsapp') !== -1 ||
        href.indexOf('whatsapp') !== -1 || href.indexOf('wa.me') !== -1 ||
        src.indexOf('whatsapp') !== -1 || title.indexOf('whatsapp') !== -1;
    }

    function findWhatsAppButton(root, depth) {
      if (!root || depth > 4) return null;
      var all = root.querySelectorAll ? root.querySelectorAll('*') : [];
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (looksLikeWhatsApp(el)) {
          var fixedEl = findFixedWithin(el) || (el.shadowRoot && findFixedWithin(el.shadowRoot));
          if (fixedEl) return fixedEl;
        }
        if (el.shadowRoot) {
          var found = findWhatsAppButton(el.shadowRoot, depth + 1);
          if (found) return found;
        }
      }
      return null;
    }

    function updateScrollTopOffset() {
      if (!isMobile()) return;
      var scrollTopBtn = document.querySelector('.btn--scroll-top');
      if (!scrollTopBtn) return;
      var waButton = findWhatsAppButton(document, 0);
      if (!waButton) return;
      var waRect = waButton.getBoundingClientRect();
      if (waRect.width === 0 || waRect.height === 0) return;
      var ownHeight = scrollTopBtn.getBoundingClientRect().height || 60;
      var gap = 10;
      var waBottomOffset = window.innerHeight - waRect.bottom;
      var ourBottom = Math.round(waBottomOffset - ownHeight - gap);
      if (ourBottom >= 0) {
        document.documentElement.style.setProperty('--chilla-scroll-top-bottom', ourBottom + 'px');
      }
    }

    window.addEventListener('load', function () {
      updateScrollTopOffset();
      setTimeout(updateScrollTopOffset, 1500);
      setTimeout(updateScrollTopOffset, 4000);
    });
    window.addEventListener('resize', updateScrollTopOffset);

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        updateScrollTopOffset();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
